import { render, staticRenderFns } from "./BlockEditorStyledText.vue?vue&type=template&id=77360a59&"
import script from "./BlockEditorStyledText.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorStyledText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports